import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";

interface YearSearchProps {
  onSearch: (year: number) => void;
  loading?: boolean;
}

export default function YearSearch({ onSearch, loading = false }: YearSearchProps) {
  const [year, setYear] = useState<string>("");
  const [error, setError] = useState<string>("");

  const handleSearch = () => {
    setError("");
    const yearNum = parseInt(year, 10);

    if (!year.trim()) {
      setError("Please enter a year");
      return;
    }

    if (isNaN(yearNum) || yearNum < -4000 || yearNum > 2100) {
      setError("Enter a year between -4000 and 2100");
      return;
    }

    onSearch(yearNum);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <div className="w-full max-w-md mx-auto space-y-3">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground pointer-events-none" />
          <Input
            type="number"
            placeholder="Enter a year (e.g., 1969)"
            value={year}
            onChange={(e) => {
              setYear(e.target.value);
              setError("");
            }}
            onKeyPress={handleKeyPress}
            className="pl-10"
            disabled={loading}
          />
        </div>
        <Button
          onClick={handleSearch}
          disabled={loading}
          className="px-6"
        >
          {loading ? "Searching..." : "Explore"}
        </Button>
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
}
